import React from 'react';
export function TestimonialSection() {
  return <section className="mb-16" data-id="element-113">
      <h2 className="text-2xl font-bold text-teal-700 mb-8 text-center" data-id="element-114">
        Here's what people are saying about this approach:
      </h2>
      <div className="grid md:grid-cols-2 gap-6 mb-8" data-id="element-115">
        <div className="bg-gray-50 p-6 rounded-lg shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-116">
          <div className="flex items-center justify-between mb-4" data-id="element-117">
            <div className="flex items-center" data-id="element-118">
              <div className="w-12 h-12 rounded-full bg-teal-100 flex items-center justify-center text-xl font-semibold text-teal-700" data-id="element-119">
                EP
              </div>
              <div className="ml-4" data-id="element-120">
                <h3 className="font-semibold" data-id="element-121">Elle Perry</h3>
                <p className="text-gray-600" data-id="element-122">AU • 1 review</p>
              </div>
            </div>
            <div className="text-gray-600" data-id="element-123">Apr 30, 2025</div>
          </div>
          <div className="flex mb-2" data-id="element-124">
            {'★★★★★'.split('').map((star, i) => <span key={i} className="text-green-500" data-id="element-125">
                {star}
              </span>)}
          </div>
          <p className="text-lg font-medium mb-4" data-id="element-126">
            After struggling with anxiety and...
          </p>
          <p className="text-gray-700" data-id="element-127">
            After struggling with anxiety and burnout for years, the 30-Day
            Vagus Nerve Reset felt like a gentle way back to myself. I
            appreciated the short daily sessions—I never felt overwhelmed or
            like I was doing it "wrong." What stood out most was how calm I
            began to feel just a few days in. I wasn't expecting such a shift so
            soon.
          </p>
        </div>
        <div className="bg-gray-50 p-6 rounded-lg shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-128">
          <div className="flex items-center justify-between mb-4" data-id="element-129">
            <div className="flex items-center" data-id="element-130">
              <div className="w-12 h-12 rounded-full bg-teal-100 flex items-center justify-center text-xl font-semibold text-teal-700" data-id="element-131">
                JV
              </div>
              <div className="ml-4" data-id="element-132">
                <h3 className="font-semibold" data-id="element-133">Julia Vogt</h3>
                <p className="text-gray-600" data-id="element-134">DE • 1 review</p>
              </div>
            </div>
            <div className="text-gray-600" data-id="element-135">Apr 18, 2025</div>
          </div>
          <div className="flex mb-2" data-id="element-136">
            {'★★★★★'.split('').map((star, i) => <span key={i} className="text-green-500" data-id="element-137">
                {star}
              </span>)}
          </div>
          <p className="text-lg font-medium mb-4" data-id="element-138">
            Wasn't expecting much tbh but WOW
          </p>
          <p className="text-gray-700" data-id="element-139">
            Wasn't expecting much tbh but WOW. like actually wow. The way it's
            laid out is so easy to follow and not overwhelming which I NEED lol.
            first few days i was still kind of anxious but then something
            clicked. more grounded, less reactive, even my partner noticed. It's
            not magic but it kinda feels like it?
          </p>
        </div>
      </div>
      <div className="bg-gray-50 p-6 rounded-lg shadow-sm border border-gray-100 hover:shadow-md transition-shadow mb-8" data-id="element-140">
        <div className="flex items-center justify-between mb-4" data-id="element-141">
          <div className="flex items-center" data-id="element-142">
            <div className="w-12 h-12 rounded-full bg-teal-100 flex items-center justify-center text-xl font-semibold text-teal-700" data-id="element-143">
              MP
            </div>
            <div className="ml-4" data-id="element-144">
              <h3 className="font-semibold" data-id="element-145">Mihaela Pavlic Lisac</h3>
              <p className="text-gray-600" data-id="element-146">HR • 4 reviews</p>
            </div>
          </div>
          <div className="text-gray-600" data-id="element-147">7 hours ago</div>
        </div>
        <div className="flex mb-2" data-id="element-148">
          {'★★★★★'.split('').map((star, i) => <span key={i} className="text-green-500" data-id="element-149">
              {star}
            </span>)}
        </div>
        <p className="text-lg font-medium mb-4" data-id="element-150">
          Kind and effective daily support from Neurotoned
        </p>
        <p className="text-gray-700" data-id="element-151">
          If you feel tired, stressed, anxious, burned out and demotivated to
          step out from this exhausted circle, these beautiful people from
          <strong data-id="element-152">
            <a href="https://www.neurotoned.com/41-off-neuro" className="text-teal-600 hover:text-teal-700" data-id="element-153">
              {' Neurotoned'}
            </a>
          </strong>{' '}
          help you with simple but meaningful small steps. Breathing exercises,
          talk, and other somatic techniques to help you feel better. Nobody is
          pushing you, you can do it in your own pace. They are here for your
          every question and doubt, they give you daily support with kind words
          and advice. Couldn't recommend more ❤️.
        </p>
      </div>
      <div className="text-center mb-8" data-id="element-154">
        <a href="https://www.trustpilot.com/review/neurotoned.com" className="inline-block bg-teal-600 text-white font-semibold py-3 px-6 rounded-lg hover:bg-teal-700 transition-colors shadow-sm" data-id="element-155">
          See More Reviews
        </a>
      </div>
      <p className="text-lg mb-6" data-id="element-156">
        If this resonates with you, I highly recommend exploring this approach
        to vagus nerve retraining.
      </p>
      <p className="text-lg mb-6" data-id="element-157">
        There is a program called the{' '}
        <strong data-id="element-158">
          <a href="https://www.neurotoned.com/41-off-neuro" className="text-teal-600 hover:text-teal-700" data-id="element-159">
            Neurotoned Vagus Nerve Reset
          </a>
        </strong>{' '}
        that follows exactly this gentle, science-backed path — and it's helped
        thousands of people like me shift out of survival mode.
      </p>
    </section>;
}